import styled from 'styled-components';

const DropdownContainer = styled.div`
  position: relative;
  vertical-align: middle;
`;

export default DropdownContainer;
